export default process.env.GATSBY_OFFLINE === 'true';